import Vue from "vue";
export const bus = new Vue();



// WEBPACK FOOTER //
// ./src/components/map-control/utils/bus.js